import React from 'react';
import ProposalBoxAlign from '../../proposal/ProposalBoxAlign/ProposalBoxAlign';
import CtaButton from '../shared/CtaButton';
import { textRoleCss } from '../../../puck/fields/TextRolesField';

/**
 * Bloc Puck — Bouton. Box autonome : elle vit dans une colonne de Bloc, porte
 * son alignement, et laisse au Bloc la visibilité et l'animation.
 *
 * Le libellé s'écrit sur le canvas (règle InfoCard) ; seuls le lien et
 * l'apparence sont en sidebar.
 *
 * `innerMode="shrink"` : sans lui la box occuperait toute la largeur de la
 * colonne et l'alignement horizontal n'aurait aucun effet visible.
 */
const ButtonBlock = ({
  id,
  label = '',
  /** Ancienne cible, texte libre. Lue quand `link` est absent. */
  url = '',
  /** Cible typée : page, bloc, URL, e-mail, téléphone. */
  link = undefined,
  color = '',
  size = 'md',
  radius = 'xl',
  /** Arrondi au pixel + traits — absent sur les boutons antérieurs au chantier. */
  border = undefined,
  /** Variante, dégradé, ombre, padding, états — idem. */
  buttonStyle = undefined,
  /** Nom d'icône Tabler ; son côté vit dans `buttonStyle.iconSide`. */
  icon = '',
  iconColor = '',
  alignHorizontal = 'center',
  alignVertical = 'center',
  /** Style par défaut du texte, par rôle (`label`). */
  textStyles = null,
  /** Sur-titre au-dessus du libellé (« Chapitre suivant »), écrit sur le
   *  canvas ; affiché seulement quand `showCaption` est allumé. */
  showCaption = false,
  caption = '',
  /** Toute la largeur de la colonne — avec « Toute la hauteur », le bouton
   *  devient un panneau (chapitre précédent / suivant). */
  fullWidth = false,
  isVisible = true,
  puck,
}) => {
  const isEditing = !!puck?.isEditing;
  if (!isVisible && !isEditing) return null;

  return (
    <ProposalBoxAlign
      horizontal={alignHorizontal}
      vertical={alignVertical}
      innerMode={fullWidth ? 'full' : 'shrink'}
    >
      <CtaButton
        id={id}
        puck={puck}
        label={label}
        contentProp="label"
        url={url}
        link={link}
        size={size}
        radius={radius}
        border={border}
        buttonStyle={buttonStyle}
        color={color || undefined}
        icon={icon}
        iconColor={iconColor}
        labelStyle={textRoleCss(textStyles, 'label')}
        caption={showCaption ? caption : null}
        captionProp="caption"
        captionStyle={textRoleCss(textStyles, 'caption')}
        fullWidth={fullWidth}
      />
    </ProposalBoxAlign>
  );
};

export default ButtonBlock;
